module.exports = __webpack_public_path__ + "img/WPS图片(1)@2x.856fea34.png";